import React, {FC} from 'react';

import {Link} from "react-router-dom";
import {Card, Typography} from "@mui/material";
import {sx} from "./sx";
import {IReportNavigateItem} from "@containers/reports/readyReports/navigateReadyReports/types";
import {useTranslation} from "react-i18next";
import {classNames} from "@helpers/classNames";

interface IProps extends IReportNavigateItem {
    active: boolean
}

const NavigateReadyReportsItem: FC<IProps> = ({path, label, active}) => {

    const {t} = useTranslation()

    return (
        <Link to={path}>
            <Card
                className={classNames(active && 'active')}
                sx={sx.root}
            >
                <Typography
                    sx={sx.name}
                    className={classNames(active && 'active')}

                >
                    {t(label)}
                </Typography>
            </Card>
        </Link>
    );
};

export default NavigateReadyReportsItem;